"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSG_TYPE_SHARE = '@lepont/share/share';
